import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Typography } from "antd";

import img403 from "../images/403.png";

const Forbidden = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { Title } = Typography;

  return (
    <div className="container-image-responsive">
      <Typography style={{ textAlign: "center" }}>
        <img
          src={img403}
          alt={t("403")}
          className="image-responsive"
          style={{ maxWidth: "500px" }}
        />
        <Title level={3}>{t("403").toUpperCase()}</Title>
        <Button shape="round" type="primary" onClick={() => history.push("/")}>
          HOME PAGE
        </Button>
      </Typography>
    </div>
  );
};

export default Forbidden;
